<template>
  <div class="dropdown" :class="{ oneLine: oneLine }">
    <label class="dropdown__label" v-if="placeholder">{{ placeholder }}</label>
    <div class="dropdown__select-wrapper">
      <div
        :class="{ oneLine: oneLine, open: open, disabled: disabled }"
        class="dropdown__select"
        @click.stop="openList">
        <input
        :disabled="disabled"
        :name="name"
        :placeholder="inlinePlaceholder"
        :value="getValue"
        class="dropdown__input"
        readonly
        @keyup.enter="arrowSelect"
        @keyup.38="arrowUp"
        @keyup.40="arrowDown" />
        <icon
          :class="{ 'icon-disabled': disabled }"
          :type="open ? 'caret-up' : 'caret-down'">
        </icon>
      </div>

      <ul class="dropdown__list" ref="results" v-if="displayList">
        <li
          v-for="(option, index) in filteredOptions"
          :class="{ active: arrowSelected === index }"
          :key="index"
          class="dropdown__list-item"
          ref="resultItem"
          @click="setOption(option)">
          {{ option[selector] }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'SearchDropdown',
  components: {
    Icon
  },
  props: {
    oneLine: { default: false, type: Boolean },
    options: { default: [], type: Array },
    placeholder: String,
    inlinePlaceholder: {
      default: '',
      type: String
    },
    disabled: { default: false, type: Boolean },
    name: String,
    selector: { default: 'name', type: String },
    value: { default: null }
  },
  data() {
    return {
      arrowSelected: null,
      open: false
    }
  },
  mounted() {
    document.addEventListener('click', this.closeList)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeList)
  },
  computed: {
    getValue() {
      if (this.options) {
        const found = this.options.find(({ path }) => path === this.value)
        return (found && found.name) || ''
      }
      
      return null
    },
    displayList() {
      return this.open && this.options && this.options.length
    },
    filteredOptions() {
      if (this.options.length) {
        return this.options
      }
    }
  },
  methods: {
    arrowDown() {
      if (this.arrowSelected === null) {
        this.arrowSelected = 0
        return
      }

      if (
        this.filteredOptions &&
        this.arrowSelected >= this.filteredOptions.length - 1
      ) {
        return
      }

      if (this.arrowSelected >= 2) {
        this.$refs.results.scrollTop += this.$refs.resultItem[
          this.arrowSelected
        ].offsetHeight
      }

      this.arrowSelected += 1
    },
    arrowUp() {
      if (this.arrowSelected === null) {
        return
      }

      if (this.arrowSelected === -1) {
        this.arrowSelected = null
        return
      }

      if (this.arrowSelected >= 2) {
        this.$refs.results.scrollTop -= this.$refs.resultItem[
          this.arrowSelected
        ].offsetHeight
      }

      this.arrowSelected -= 1
    },
    arrowSelect() {
      if (this.arrowSelected === null) {
        const option = this.filteredOptions.filter(
          ({ path }) => path === this.value
        )[0]
        this.setOption(option)
        return
      }

      this.setOption(this.filteredOptions[this.arrowSelected])
    },
    setOption(option) {
      this.arrowSelected = null
      this.open = false
      this.$emit('changed', option)
    },
    emitChange(value) {
      this.$emit('inputChange', value)
    },
    openList() {
      if (this.disabled) {
        return false
      }
      this.open = true
    },
    closeList() {
      this.open = false
    }
  }
}
</script>

<style lang="postcss" scoped>
.dropdown {
  &.oneLine {
    display: flex;
    align-items: center;

    & > .dropdown__label {
      margin-right: var(--spacing-third);
    }
  }
}

.dropdown__label {
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
}

.dropdown__select-wrapper {
  position: relative;
}

.dropdown__select {
  background-color: var(--color-white);
  border: 1px solid var(--color-silver);
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  display: flex;
  margin-bottom: var(--spacing-third);
  padding: var(--spacing-third) var(--spacing-half);
  transition: border-color ease-in-out 150ms, box-shadow ease-in-out 150ms;

  &.open {
    border-radius: 4px 4px 0 0;
  }

  &.disabled {
    background-color: var(--color-porcelain);
  }

  &.oneLine {
    margin-bottom: 0;
  }
}

.dropdown__input {
  background-color: transparent;
  border: none;
  flex: 1;
  font-family: var(--font-default);
  font-size: 16px;
  margin-right: var(--spacing-third);

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: var(--color-black);
  }
}

.icon-disabled {
  opacity: 0.35;
}

.dropdown__list {
  background-color: var(--color-white);
  border: 1px solid var(--color-silver-sand);
  border-radius: 0 0 4px 4px;
  border-top: 0;
  font-size: 16px;
  left: 0;
  max-height: 315px;
  overflow: auto;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 2;
}

.dropdown__list-item {
  cursor: pointer;
  padding: 10px var(--spacing-half);

  &:active,
  &:hover {
    background-color: var(--color-link-water);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchDropdown.vue